import Swal from 'sweetalert2'

interface ReadNotificationResponse {
    success: boolean;
    message: string;
}

export async function markNotificationAsRead(
    notificationIdentifier: string,
    element: HTMLElement|null = null,
) {
    await fetch(new URL('/api/notifications/read', window.location.origin), {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({
            notification: notificationIdentifier,
        }),
    })
        .then(response => response.json())
        .then((data: ReadNotificationResponse) => {
            if (data.success && element instanceof HTMLElement) {
                element.classList.add('bg-gray-light');
            }

            if (!data.success) {
                console.error(data.message);
                Swal.fire({
                    position: "top-end",
                    icon: "error",
                    title: "Benachrichtigung konnte nicht als gelesen markiert werden.",
                    text: data.message,
                    showConfirmButton: false,
                    timer: 1300,
                    toast: true,
                });

                element.remove();
            }
        });
}

export function readNotifications() {
    const notifications = document.querySelectorAll('#page-header-notifications .notification-item[data-notification-identifier]');


    notifications.forEach((notification: HTMLElement) => {
        // the mouse has to be over the element for 1 seconds to trigger a function
        let timeout: number;

        // ToDo: Use Service-Worker for mobile?
        notification.addEventListener('mouseover', async () => {
            const notificationId = notification.getAttribute('data-notification-identifier');

            await new Promise((resolve) => timeout = setTimeout(resolve, 600));

            markNotificationAsRead(notificationId, notification);
        }, {passive: true});

        notification.addEventListener('mouseout', () => {
            clearTimeout(timeout);
        });
    });
}

readNotifications();
